import {langCodes, unindexedLocales, urlPrefix} from './localePrefix'

// Non-public paths, written in their English form. Matching is segment-aware and runs on
// the locale-stripped path, so /et/register is covered by '/register'.
// A route whose slug is LOCALIZED cannot be listed here — its Estonian or Spanish path is a
// different word — so those routes must set meta.noindex on every locale variant instead.
const NOINDEX_PATHS = [
  '/account', '/settings', '/investments', '/invest', '/strategy',
  '/withdraw', '/deposit', '/confirm-investment', '/loan',
  '/payment-schedule-details', '/notification-settings', '/login-callback',
  '/register-complete', '/logout', '/404',
  '/login', '/register', '/reset-password'
]
const UNINDEXED_PREFIXES = unindexedLocales.map(urlPrefix)

export function stripLocalePrefix(path)
{
  return Object.keys(langCodes).map(urlPrefix).filter(Boolean).reduce((stripped, prefix) =>
    (stripped === prefix || stripped.startsWith(prefix + '/'))
      ? (stripped.slice(prefix.length) || '/')
      : stripped, path)
}

export default function shouldNoindex(path, meta)
{
  const routeMeta = meta || {}
  if (routeMeta.noindex || routeMeta.type === 'auth')
  {
    return true
  }
  if (UNINDEXED_PREFIXES.some(prefix => path === prefix || path.startsWith(prefix + '/')))
  {
    return true
  }
  const stripped = stripLocalePrefix(path)

  return NOINDEX_PATHS.some(p => stripped === p || stripped.startsWith(p + '/'))
}
